import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import frFlag from '../assets/images/flags/fr.svg';
import gbFlag from '../assets/images/flags/gb.svg';

const LanguageSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

const LanguageButton = styled.button`
  background: none;
  border: ${({ active }) => active ? '2px solid #fff' : 'none'};
  padding: 0;
  cursor: pointer;
  margin: 0 5px;
  transition: all 0.2s ease;
  width: 24px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  opacity: ${({ active }) => active ? '1' : '0.7'};
  
  &:hover {
    opacity: 1;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLanguageChange = (newLang) => {
    // Change language in context
    changeLanguage(newLang);
    
    // Update URL to reflect the new language
    const currentPath = location.pathname;
    const pathParts = currentPath.split('/');
    
    // Replace language code or add it if it's missing
    if (pathParts.length >= 2 && (pathParts[1] === 'fr' || pathParts[1] === 'en')) {
      pathParts[1] = newLang;
    } else {
      // Handle case where there's no language code yet
      pathParts.splice(1, 0, newLang);
    }
    
    // Navigate to the new URL
    navigate(pathParts.join('/') + location.search);
  };
  
  return (
    <LanguageSelectorContainer>
      <LanguageButton 
        active={language === 'fr'} 
        onClick={() => handleLanguageChange('fr')}
        title="Français"
      >
        <img src={frFlag} alt="Drapeau français" />
      </LanguageButton>
      <LanguageButton 
        active={language === 'en'} 
        onClick={() => handleLanguageChange('en')}
        title="English"
      >
        <img src={gbFlag} alt="British flag" />
      </LanguageButton>
    </LanguageSelectorContainer>
  );
};

export default LanguageSelector;
